export default "__VITE_ASSET__69ipTTN7__"